import { useState } from "react";
import { MyLoader } from "@/components/loaders/SkeletonLoader";
import SearchBar from "@/components/SearchBar";
import MySelectSimple from "@/components/MySelectSimple";
import MyHeaderLabel from "@/components/MyHeaderLabel";
import { MyTableViewJSON } from "@/components/MyTableViewJSON";
import { useDialog } from "@/context/DialogContext";
import { useUpdatePost } from "@/hooks/useUpdatePost";
import { useLang } from "@/context/TranslationProvider";
import { useDeletePost } from "@/hooks/useDeletePost";
import { useConfirmDialog } from "@/hooks/useConfirmDialog";
import { MyInfiniteLoadMore } from "@/components/MyInfiniteLoadMore";
import MyDialogButton from "@/MY_COMPONENTS/MyDialogButton";
import { myGetList } from "@/hooks/myGetList";
import { MY_ENDPOINTS } from "@vehidhi/shared";
import AddProfileForm from "./AddProfileForm";
import ProfileView from "./ProfileView";
import { useMyDialog } from "@/context/MyDialogProvider";
import AdminAddProfileForm from "./AdminAddProfileForm";



export default function AdminManageProfiles() {
  const {t} = useLang();
  const { open, close } = useMyDialog();
  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);
  const { confirm } = useConfirmDialog();
  const { mutate: updatePost, isPending } = useUpdatePost();
  const deletePost = useDeletePost();


  const {
    data,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = myGetList({
    endpoint: MY_ENDPOINTS.PROFILES_ENDPOINTS.ADMIN_GET_ALL_PROFILES.path,
    method: "GET",
    key: ["admingetallprofiles"],
  });

  if (isPending) return <MyLoader />;

  // flatten pages
  const itemsList = data?.pages.flatMap((p) => p.data) ?? [];

  const renderPostsTable = () => {
    if (!itemsList || itemsList.length === 0) return <div>No posts found</div>;

    return (
      <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
        <MyTableViewJSON
          data={itemsList}
        //   switchColumns={["is_published"]}
          handleToggle={(row, col) => {
            updatePost({ post_id: row.post_id, [col]: !row[col] });
          }}
          columns={["user_id", "age", "gender", "marital_status", "seeking_status", "created_at"]}
          actions={[
            // {
            //   label: "✍",
            //   onClick: (row) =>
            //     open(
            //       <EditProfileForm
            //         post={row}
            //         onSave={(updatedPost) => {
            //           console.log("Save post", updatedPost);
            //           updatePost(updatedPost);
            //           close();
            //         }}
            //         onCancel={() => close()}
            //       />,
            //       <MyHeaderLabel label="Edit Post" />
            //     ),
            // },
            {
              label: "📖",
              onClick: (row) =>
                open({
                  content: <ProfileView
                    profile={row}
                    onClose={() => close()}
                  />,
                  header: <MyHeaderLabel label={`${t('post_id')} ${row.post_id}`} />
                }),
            },
            {
              label: "❌",
              onClick: (row) => {
                confirm({
                  title: t("Delete Post"),
                  message: `${t("Are you sure you want to")} ${t("Delete")} "${row.post_title_dv}"?`,
                  onConfirm: () => deletePost.mutate(row.post_id),
                });
              },
              className: "bg-red-200 hover:bg-red-300",
            }
          ]}
        />
      </div>
    );
  };

  return (
    <div className="p-4 sm:p-6 max-w-screen-xl mx-auto">
      
      <MyHeaderLabel label="Posts Management"/>

      <div className="h-6"></div>

      {/* Filters & Search */}
      <div className="mb-4 flex flex-wrap gap-2">

        <SearchBar
          onSearch={(v => setSearch(v))}
        />


        {/* <MySelectSimple
          options={}
          value={categoryFilter}
          onChange={setCategoryFilter as any}
          placeholder="Select a category"
        /> */}

      </div>


      <div className="flex items-center justify-between ">
        <MyDialogButton label="Add Profile" dialogHeader={<MyHeaderLabel label="Add Profile" />} dialogContent={<AdminAddProfileForm />} />
  
      </div>

      <div className="h-5"></div>

      {isPending ? (
        <div><MyLoader /></div>
      ) : isError ? (
        <div>Failed to load posts.</div>
      ) : (
        renderPostsTable()
      )}

      <MyInfiniteLoadMore
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                fetchNextPage={fetchNextPage}
              />

    </div>
  );
}